import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CopyTextFieldIcon } from "@common/CopyTextField/CopyTextFieldIcon";

interface IParams {
    pinNumber: string;
    pukNumber: string;
}

export const PinPuk = (props: IParams) => {
    const { pinNumber, pukNumber } = props;
    const { t } = useTranslation("accountDetails");

    return (
        <Stack alignItems="start" direction="row" spacing={{ xs: 0, sm: 2 }}>
            <Stack flex={1} spacing={2}>
                <Stack alignItems="center" direction="row" spacing={3}>
                    <Stack>
                        <Typography color="secondary" fontWeight="bold" variant="normal">
                            {t("PIN")}:
                        </Typography>
                        <Typography color="secondary" variant="normal">
                            {pinNumber}
                        </Typography>
                    </Stack>
                    <CopyTextFieldIcon textToCopy={pinNumber} />
                </Stack>
                <Typography color="secondary" variant="small">
                    {t("originalPIN")}
                </Typography>
            </Stack>
            <Stack alignItems="center" direction="row" flex={1} spacing={3}>
                <Stack>
                    <Typography color="secondary" fontWeight="bold" variant="normal">
                        {t("PUK")}:
                    </Typography>
                    <Typography color="secondary" variant="normal">
                        {pukNumber}
                    </Typography>
                </Stack>
                <CopyTextFieldIcon textToCopy={pukNumber} />
            </Stack>
        </Stack>
    );
};
